import classNames from "classnames"

import { Color } from "../../../../constants/V2/color"
import { getTextColorClass } from "../../../../utils/V2/color"

import React from "react"

type Props = {
  overrideColor?: Color
}

const CircleOutlineCheckIcon = ({ overrideColor = Color.Charcoal }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      className={classNames("self-start", getTextColorClass(overrideColor))}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path
        stroke="currentColor"
        d="M20 12a8 8 0 1 1-16 0 8 8 0 0 1 8-8 8 8 0 0 1 8 8Z"
        opacity={0.3}
      />
      <path stroke="currentColor" d="m9.082 12 2.245 2.245 4.082-4.082" />
    </svg>
  )
}

export default CircleOutlineCheckIcon
